{
  "actions.activate": "Attivare",
  "actions.add": "Aggiungere",
  "actions.add_deadline": "Aggiungere la scadenza",
  "actions.addresses": "Indirizzi",
  "actions.ai_translation": "Traduzione AI",
  "actions.apply": "Applica",
  "actions.cancel": "Annullare",
  "actions.continue": "Continuare",
  "actions.copy_email": "Copy E-mail",
  "actions.copy_link": "Copia il link",
  "actions.create": "Crea",
  "actions.create_box": "Create Box",
  "actions.create_file": "Crea file",
  "actions.deactivate": "Disattivare",
  "actions.delete": "Cancella",
  "actions.disabled": "disabilitato",
  "actions.download": "Scaricare",
  "actions.duplicate": "Duplicare",
  "actions.edit": "Modificare",
  "actions.edit_deadline": "Modificare la scadenza",
  "actions.folder": "Nuova cartella",
  "actions.install_app": "Installare l'app DeepBox",
  "actions.language": "Lingua",
  "actions.load_more": "Carica di più...",
  "actions.login": "Accesso",
  "actions.logout": "Logout",
  "actions.manage": "Maneggio",
  "actions.manage_your_account": "Gestire l'account",
  "actions.more": "Di Più..",
  "actions.more_boxes": "Più box...",
  "actions.move": "Spostare",
  "actions.move_to": "Spostare in {nodeName}",
  "actions.new": "Nuovo",
  "actions.new_entry": "Nuova iscrizione",
  "actions.no": "No",
  "actions.ok": "Ok",
  "actions.open_details": "Apri dettagli",
  "actions.open_service": "Aprire {service}",
  "actions.preview": "Anteprima",
  "actions.refresh": "Ricaricare",
  "actions.remove": "Rimuovere",
  "actions.rename": "Rinominare",
  "actions.reset": "Reset",
  "actions.reset_search": "Ripristina la ricerca",
  "actions.save": "Salvare",
  "actions.select": "Selezionare",
  "actions.try_again": "Riprovare",
  "actions.upload": "Carica",
  "actions.upload_file": "Caricare files",
  "actions.upload_folder": "Carica cartella",
  "actions.view": "Vista",
  "actions.yes": "Sì",
  "admin.navigation.account": "CONTO",
  "admin.navigation.account_profile": "Il tuo profilo",
  "admin.navigation.organization": "Organizzazione",
  "admin.navigation.organization_boxes": "Box",
  "admin.navigation.organization_boxes_tags": "Tags",
  "admin.navigation.organization_groups": "Gruppi",
  "admin.navigation.organization_personal": "Informazioni personali",
  "admin.navigation.organization_subheader": "ORGANIZZAZIONE",
  "admin.navigation.organization_subscription": "Abbonamento",
  "admin.navigation.organization_users": "Utente",
  "admin.navigation.organization_verification_in_progress": "Verifica",
  "alerts.aba_ninja.continue_process": "Questo box è collegato a DeepNinja. ",
  "alerts.box.only_advanced_box_selectable": "È possibile selezionare solo una box del tipo “Advanced\".",
  "alerts.company_accounting.open_invoices.action": "Alle fatture",
  "alerts.company_accounting.open_invoices.label": "Pagamento in sospeso",
  "alerts.company_accounting.open_invoices.member.content": "La propria organizzazione presenta almeno una fattura non pagata. Si prega di informare l'Owner dell'organizzazione, poiché le fatture non pagate potrebbero comportare la disattivazione dell'organizzazione.",
  "alerts.company_accounting.open_invoices.owner.content": "È presente almeno una fattura non pagata. Si prega di saldarla per evitare la disattivazione della propria organizzazione.",
  "alerts.company_accounting.overusing.action": "Controlla il tuo abbonamento.",
  "alerts.company_accounting.overusing.label": "Sovraccarico di capacità",
  "alerts.company_accounting.overusing.member.content": "L'organizzazione sta attualmente utilizzando più capacità di quella disponibile con l'abbonamento. Un utilizzo eccessivo della capacità potrebbe comportare la disattivazione dell'organizzazione. Si prega di informare il Owner dell'organizzazione.",
  "alerts.company_accounting.overusing.owner.content": "La tua organizzazione sta attualmente utilizzando più capacità di quella inclusa nell'abbonamento. Si prega di aggiornare l'abbonamento o ridurre l'utilizzo per evitare la disattivazione dell'organizzazione.",
  "alerts.company_verification.action": "Procedere",
  "alerts.company_verification.content": "Il processo di verifica è in corso. Potrai creare la prima box non appena la verifica sara stata completata.",
  "alerts.company_verification.title": "Verifica",
  "alerts.hoop.continue_process": "Questa box è collegata ad Hoop. Su Hoop puoi verificare in qualsiasi momento lo stato di costituzione/mutazione della società.",
  "alerts.portal.continue_process": "Questa box è collegata a DeepPortal.",
  "api.deepbox.errors.node.move.out-of-box.prohibited.generic-folder": "Impossibile spostare una cartella generica in un'altra box. | {n} cartelle generiche non possono essere spostate in un'altra box.",
  "api.deepbox.errors.node.move.out-of-box.prohibited.shared-folder": "Impossibile spostare la cartella condivisa in un'altra box. | {n} cartelle condivise non possono essere spostate su un'altra box.",
  "api.deepbox.errors.node.move.recursive": "Una cartella padre non può essere spostata in una cartella figlio. | {n} cartelle padre non possono essere spostate in una cartella figlio.",
  "apps.subtitle.deepbox": "Archiviazione e condivisione di documenti sicura",
  "apps.subtitle.deepsign": "Firme elettroniche sicure e a norma legge",
  "base.date_picker.example_date": "Es.: {example}",
  "base.date_picker.modal_btn_cancel": "Annullare",
  "base.date_picker.modal_btn_save": "Salvare",
  "box.boxes_switch": "Boxes",
  "box.n_selected_detail": "1 selezionato ({detail}) | {n} selezionato ({detail})",
  "box.policies.can_not_access_inbox_and_files.text": "Non hai il permesso di spostare i file nella posizione selezionata",
  "box.private.generics.deepmail.error.logged_in_wrong_account.message": "Sei attualmente connesso con l'utente <b>{userEmail}</b><br />Il messaggio crittografato è stato inviato all'indirizzo e-mail <b>{queryEmail}</b>. Dovrai accedere con questo indirizzo e-mail.",
  "box.private.generics.deepmail.error.logged_in_wrong_account.title": "Sei connesso con l'account sbagliato",
  "box.private.generics.deepmail.title": "DeepMail",
  "box.private.generics.deepsign.banner.content": "Dans le dossier DeepSign, vous trouverez tous les documents terminés. Pour les processus de signature en attente ou nouveaux, veuillez passer à {link}",
  "box.private.generics.deepsign.banner.link": "application DeepSign",
  "box.private.generics.deepsign.title": "Archiviazione DeepSign",
  "box.types.advanced": "Advanced Box",
  "box.types.advanced_per_use": "Advanced Box a prezzo fisso",
  "box.types.portal": "Portal",
  "box.types.simple": "Simple Box",
  "box_details.access.error.forbidden": "La cartella non esiste o non si ha il permesso di accedere a questa cartella.",
  "box_details.archive.banner.subtitle": "Integrità verificabile",
  "box_details.archive.banner.text": "Immutabile · Conservazione per 10 anni dalla ricezione · Marca temporale qualificata secondo ZertES",
  "box_details.all_files_reviewed": "Tutti i file sono stati verificati.",
  "box_details.details_drawer.amount": "Importo",
  "box_details.details_drawer.attributes": "Attributi",
  "box_details.details_drawer.category": "Categoria",
  "box_details.details_drawer.comments": "Commenti",
  "box_details.details_drawer.created": "Creato",
  "box_details.details_drawer.details": "Dettagli",
  "box_details.details_drawer.details_file": "Dettagli file",
  "box_details.details_drawer.details_folder": "Dettagli cartella",
  "box_details.details_drawer.file": "File",
  "box_details.details_drawer.files": "Documenti",
  "box_details.details_drawer.folder": "Cartella",
  "box_details.details_drawer.location": "Posizione",
  "box_details.details_drawer.me": "Io",
  "box_details.details_drawer.modified": "Modificato",
  "box_details.details_drawer.opened": "aperto",
  "box_details.details_drawer.owner": "Proprietario",
  "box_details.details_drawer.path": "Percorso",
  "box_details.details_drawer.queue": "Inbox",
  "box_details.details_drawer.sections.comments.counter": "Commento | Commenti",
  "box_details.details_drawer.sections.comments.text_add": "Aggiungi commento",
  "box_details.details_drawer.sections.deep_validator.actions.processing": "Attendere...",
  "box_details.details_drawer.sections.deep_validator.actions.re_validate": "Ri-validare",
  "box_details.details_drawer.sections.deep_validator.actions.validate": "Validare",
  "box_details.details_drawer.sections.deep_validator.jurisdiction": "Giurisdizione",
  "box_details.details_drawer.sections.deep_validator.jurisdictions.Unknown": "Giurisdizione sconosciuto",
  "box_details.details_drawer.sections.deep_validator.jurisdictions.ZertES": "ZertES",
  "box_details.details_drawer.sections.deep_validator.jurisdictions.eIDAS": "eIDAS",
  "box_details.details_drawer.sections.deep_validator.n_signature_status.indeterminate": "1 firma indefinita | {n} firme indefinite",
  "box_details.details_drawer.sections.deep_validator.n_signature_status.invalid": "1 firma non valida | {n} firme non valide",
  "box_details.details_drawer.sections.deep_validator.n_signature_status.unsupported": "1 firma non supportata | {n} firme non supportate",
  "box_details.details_drawer.sections.deep_validator.n_signature_status.valid": "1 firma valida | {n} firme valide",
  "box_details.details_drawer.sections.deep_validator.no_signatures_found": "Nessuna firma trovata",
  "box_details.details_drawer.sections.deep_validator.nr_of_signatures": "Numero di firme",
  "box_details.details_drawer.sections.deep_validator.signature_type": "Tipo di firma",
  "box_details.details_drawer.sections.deep_validator.signature_types.CH_QESeal": "Sigillo elettronico qualificato",
  "box_details.details_drawer.sections.deep_validator.signature_types.CH_QESig": "Firma elettronica qualificata",
  "box_details.details_drawer.sections.deep_validator.signature_types.CH_RegESeal": "Sigillo elettronico regolamentato",
  "box_details.details_drawer.sections.deep_validator.signature_types.CH_RegESig": "Firma elettronico regolamentato",
  "box_details.details_drawer.sections.deep_validator.signature_types.Indeterminate_QESeal": "Sigillo elettronico qualificato (indeterminato)",
  "box_details.details_drawer.sections.deep_validator.signature_types.Indeterminate_QESig": "Firma elettronica qualificata (indeterminato)",
  "box_details.details_drawer.sections.deep_validator.signature_types.Indeterminate_Unknown": "Firma elettronica indeterminata",
  "box_details.details_drawer.sections.deep_validator.signature_types.Not_AdES": "Firma elettronica non valida",
  "box_details.details_drawer.sections.deep_validator.signature_types.Not_AdES_but_QC": "Firma elettronica qualificata (non valida)",
  "box_details.details_drawer.sections.deep_validator.signature_types.Not_AdES_but_QC_with_QSCD": "Firma elettronica qualificata (non valida)",
  "box_details.details_drawer.sections.deep_validator.signature_types.QESeal": "Sigillo elettronico qualificato",
  "box_details.details_drawer.sections.deep_validator.signature_types.QESig": "Firma elettronica qualificata",
  "box_details.details_drawer.sections.deep_validator.signature_types.Unknown": "Tipo di firma sconosciuto",
  "box_details.details_drawer.sections.deep_validator.time_of_signature": "Data della firma",
  "box_details.details_drawer.sections.deep_validator.validation_result_indication": "Risultato della verifica",
  "box_details.details_drawer.sections.deep_validator.validation_result_indications.FAILED": "Firma non valida",
  "box_details.details_drawer.sections.deep_validator.validation_result_indications.INDETERMINATE": "La firma è indeterminata",
  "box_details.details_drawer.sections.deep_validator.validation_result_indications.NO_SIGNATURE_FOUND": "Nessuna firma trovata",
  "box_details.details_drawer.sections.deep_validator.validation_result_indications.PASSED": "La firma è valida",
  "box_details.details_drawer.sections.deep_validator.validation_result_indications.TOTAL_FAILED": "Firma non valida",
  "box_details.details_drawer.sections.deep_validator.validation_result_indications.TOTAL_PASSED": "La firma è valida",
  "box_details.details_drawer.sections.deep_validator.validation_results": "Risultato del test",
  "box_details.details_drawer.sections.tags.assign": "Assegna tags",
  "box_details.details_drawer.sections.tags.counter": "Tag | Tags",
  "box_details.details_drawer.size": "Dimensione",
  "box_details.details_drawer.tags": "Tags",
  "box_details.details_drawer.trash": "Cestino",
  "box_details.folder_is_empty": "La cartella è vuota.",
  "box_details.items": "1 Elemento | {n} Elementi",
  "box_details.load_more": "Caricare altro",
  "box_details.more": "Di più",
  "box_details.more_items": "+1 elemento | +{n} elementi",
  "box_details.navigation.deadlines": "Scadenze",
  "box_details.navigation.files": "Documenti",
  "box_details.navigation.hint": "Fare doppio clic per navigare",
  "box_details.navigation.inbox": "Inbox",
  "box_details.navigation.info_no_sub_folder": "Questa cartella non contiene alcuna sottocartella.",
  "box_details.navigation.queue": "Inbox",
  "box_details.navigation.trash": "Cestino",
  "box_details.no_items": "Nessun elemento",
  "box_details.trash.empty": "Il cestino è vuoto",
  "box_details.trash.info.empty": "Gli elementi nel cestino saranno eliminati definitivamente dopo 30 giorni. {link}",
  "box_details.trash.info.with_files": "Gli elementi nel cestino saranno eliminati definitivamente dopo 30 giorni.",
  "buttons.back": "Indietro",
  "buttons.cancel": "Annullare",
  "buttons.confirm": "Confermare",
  "buttons.continue": "Continua",
  "buttons.discard": "Cancellare",
  "buttons.done": "Fatto",
  "buttons.ignore_dev_int_only": "Ignora [Solo DEV/INT]",
  "buttons.login": "Login",
  "buttons.login_now": "Accedi ora",
  "buttons.proceed": "Continuare",
  "buttons.save": "Salvare",
  "buttons.save_and_continue": "Salva e continua",
  "buttons.save_and_verify": "Salvare e verificare",
  "buttons.send": "Inviare",
  "buttons.start_now": "Inizia ora",
  "buttons.to_deepbox": "Vai su DeepBox",
  "buttons.upload": "Carica",
  "choose_your_box": "Scegli la tua box",
  "confirmation.delete_multiple_nodes_description": "Sei sicuro di voler cancellare questi elementi? | Sei sicuro di voler cancellare {n} elementi ?",
  "confirmation.delete_multiple_nodes_title": "Cancellare",
  "confirmation.delete_permanently_description": "Sei sicuro di voler cancellare {name} in modo permanente? | Sei sicuro di voler cancellare {count} elementi in modo permanente?",
  "confirmation.delete_permanently_title": "Cancellare permanentemente",
  "confirmation.empty_trash_description": "Sei sicuro di voler cancellare tutti gli elementi nel cestino ?",
  "confirmation.empty_trash_title": "Vuotare il cestino",
  "confirmation.save_open_changes.msg": "Sono state apportate delle modifiche. Volete scartarle o salvarle?",
  "confirmation.save_open_changes.title": "Modifiche alla revisione",
  "dashboard.private.generics.deepmail.banner.subtitle": "La vostra casella di posta privata per ricevere in modo sicuro i file sensibili.",
  "dashboard.private.generics.deepmail.banner.title": "DeepMail",
  "dashboard.private.generics.deepsign.banner.subtitle": "Archiviazione per i documenti DeepSign completati",
  "dashboard.private.generics.deepsign.banner.title": "Archiviazione DeepSign",
  "dashboard.service.card.deepbox.btn": "Account DeepCloud completo",
  "dashboard.service.card.deepbox.btn_manage": "Gestire",
  "dashboard.service.card.deepbox.content": "Per utilizzare DeepBox da solo, devi completare il tuo account. {link}",
  "dashboard.service.card.deepbox.create_box.btn": "Create Box",
  "dashboard.service.card.deepbox.create_box.content": "Crea gratuitamente il tuo primo box per utilizzare la piattaforma svizzera all-in-one per lo scambio sicuro di documenti.",
  "dashboard.service.card.deepbox.create_box.content_empty_boxes": "Nessuna box è stata trovata.",
  "dashboard.service.card.deepbox.create_box.content_empty_boxes_can_not_onboard": "Non hai i permessi necessari per creare un box. <br />\nContatta un proprietario o un amministratore della tua organizzazione.",
  "dashboard.service.card.deepbox.onboarding_in_progress.btn": "Continua l'onboarding",
  "dashboard.service.card.deepbox.onboarding_in_progress.content": "Per poter utilizzare DeepBox in prima persona, devi completare l'onboarding. {link}",
  "dashboard.service.card.deepsign.content": "Firma in modo sicuro i documenti in formato elettronico.",
  "dashboard.service.card.deepsign.no_pending_signs": "Al momento non ci sono documenti da firmare.",
  "dashboard.service.card.deepsign.onboarding_in_progress.btn": "Continua l'onboarding di DeepSign",
  "dashboard.service.card.deepsign.onboarding_in_progress.content": "Completa l'onboarding di DeepSign per poter utilizzare DeepSign come iniziatore del processo. {link}",
  "dashboard.service.card.deepv.btn": "Gestire DeepV",
  "dashboard.service.card.deepv.content": "Questo conto è stato aperto esplicitamente per DeepV. Se lo desideri, puoi anche utilizzare DeepBox o DeepSign con questo account. {link}",
  "dashboard.service.card.deepv.onboarding_in_progress.btn": "Continua l'onboarding di DeepV",
  "dashboard.service.card.deepv.onboarding_in_progress.content": "Completa l'onboarding di DeepV per poter utilizzare DeepV. {link}",
  "date.added": "Aggiunto",
  "date.am": "AM",
  "date.days": "Un giorno fa | {num} giorni fa",
  "date.deleted.days": "un giorno fa | {num} giorni fa",
  "date.deleted.hours": "un'ora fa | {num} ore fa",
  "date.deleted.minutes": "un minuto fa | {num} minuti fa",
  "date.deleted.months": "un mese fa | {num} mesi fa",
  "date.deleted.now": "adesso",
  "date.deleted.years": "un anno fa | {num} anni fa",
  "date.expired": "scaduto",
  "date.hours": "Un'ora fa | {num} ore fa",
  "date.in_three_days": "in 3 giorni",
  "date.in_two_days": "in 2 giorni",
  "date.minutes": "Un minuto fa | {num} minuti fa",
  "date.months": "Un mese fa | {num} mesi fa",
  "date.now": "Adesso",
  "date.on": "il",
  "date.opened": "Aperto",
  "date.pm": "PM",
  "date.today": "Oggi",
  "date.tomorrow": "Domani",
  "date.years": "Un anno fa | {num} anni fa",
  "date.yesterday": "Ieri",
  "deep_ui_lib.core.footer.link.help": "Aiuto",
  "deep_ui_lib.core.footer.link.impressum": "Impronta",
  "deep_ui_lib.core.footer.link.privacy_policy": "Protezione dati",
  "deep_ui_lib.core.footer.link.terms_of_service": "Termini di servizio",
  "deep_ui_lib.deep_filter_menu.all": "Tutti",
  "deep_ui_lib.deep_filter_menu.clear_selected": "Cancella selezione",
  "deep_ui_lib.deep_filter_menu.no_matching_options": "Nessuna opzione corrispondente",
  "deep_ui_lib.deep_filter_menu.use_value": "Usa “{value}”",
  "deepa_chat.context_dialog_title": "Contesto della chat ({n} cartella) | Contesto della chat ({n} cartelle)",
  "deepa_chat.context_filter": "Filtra cartelle",
  "deepa_chat.context_label": "Contesto:",
  "deepa_chat.context_others": "+ {n} altro | + {n} altri",
  "deepa_chat.empty_state": "Chiedi a DeepA delle cartelle nel contesto di questa chat.",
  "deepa_chat.export.answer": "Risposta",
  "deepa_chat.export.context": "Contesto",
  "deepa_chat.export.file_name": "Nome del file",
  "deepa_chat.export.file_name_prefix": "Chat DeepA",
  "deepa_chat.export.format": "Formato",
  "deepa_chat.export.formats.docx": "Word (.docx)",
  "deepa_chat.export.formats.html": "HTML (.html)",
  "deepa_chat.export.formats.json": "JSON (.json)",
  "deepa_chat.export.formats.markdown": "Markdown (.md)",
  "deepa_chat.export.formats.pdf": "PDF (.pdf)",
  "deepa_chat.export.formats.txt": "Testo (.txt)",
  "deepa_chat.export.generated_by": "Generato da DeepA",
  "deepa_chat.export.incomplete_answer": "Questa risposta è incompleta.",
  "deepa_chat.export.leftover_file": "Il file Word temporaneo “{name}” non è stato rimosso.",
  "deepa_chat.export.location": "Salva in",
  "deepa_chat.export.no_write_permission": "Non puoi salvare file in questa cartella.",
  "deepa_chat.export.question": "Domanda",
  "deepa_chat.export.success": "Chat esportata come “{name}”",
  "deepa_chat.export.title": "Esporta chat",
  "deepa_chat.new_chat": "Nuova chat",
  "deepa_chat.new_chat_hint": "Nuova chat sulle cartelle selezionate o sulla cartella corrente se non è selezionata alcuna cartella",
  "deepa_chat.prompt_placeholder": "Chiedi a DeepA…",
  "deepa_chat.reply_stopped": "Risposta interrotta",
  "deepa_chat.start_chat_for": "Avvia una chat per “{name}”",
  "deepa_chat.stop": "Interrompi",
  "deepa_chat.title": "DeepA Chat",
  "deepmail.error.logged_in_wrong_account.message": "Attualmente sei connesso all'utente <b>{userEmail}</b>.<br />\nLa DeepMail è stata inviata all'indirizzo email <b>{queryEmail}</b>.<br />\nSi prega di accedere con l'utente corretto.",
  "deepmail.error.logged_in_wrong_account.title": "Acceduto con un utente falso",
  "deeppay.payment_order.execution_date": "Data di esecuzione",
  "deeppay.payment_order.info_line": "Linea info",
  "deeppay.payment_order.move_file_message": "Volete spostare il file nella cartella \"{folderName}\"?",
  "deeppay.payment_order.order_details": "Dettagli dell'ordine",
  "deeppay.payment_order.pay_now": "Pagare ora",
  "deeppay.payment_order.payment": "Pagamento",
  "deeppay.payment_order.payment_amount": "Importo del pagamento",
  "deeppay.payment_order.payment_reference": "Riferimento di pagamento",
  "deeppay.payment_order.recipient": "Beneficiario",
  "deeppay.payment_order.xml_download": "Scaricare XML",
  "deeppay.payment_order.yes_move": "Sì, spostare",
  "deeppay.payments_history.by_address_dialog.amount": "Importo",
  "deeppay.payments_history.by_address_dialog.created_at": "Trasmesso il",
  "deeppay.payments_history.by_address_dialog.created_by": "Trasmesso da",
  "deeppay.payments_history.by_address_dialog.destination_iban": "IBAN del destinatario",
  "deeppay.payments_history.by_address_dialog.payment_to": "Pagamenti a \"{destination}\"",
  "deeppay.payments_history.by_address_dialog.status": "Stato",
  "deeppay.payments_history.card_expandable.title": "Cronologia dei pagamenti",
  "deeppay.payments_history.list.created_by": "Trasmesso da",
  "deeppay.payments_history.list.destination": "Destinazione",
  "deeppay.payments_history.list.status.declined": "Declinato",
  "deeppay.payments_history.list.status.paid": "Pagato",
  "deeppay.payments_history.list.status.transmitted": "Trasmesso",
  "dialogs.add": "Aggiungi",
  "dialogs.add_deadline_title": "Aggiungere la scadenza",
  "dialogs.box": "Box",
  "dialogs.cancel": "Annullare",
  "dialogs.change": "Cambia",
  "dialogs.close": "Chiudere",
  "dialogs.create": "Crea",
  "dialogs.create_new_deepbox.msg": "Vuoi creare un box gratuito?",
  "dialogs.create_new_deepbox.title": "Creare box",
  "dialogs.details": "Dettagli",
  "dialogs.discard.btn": "Cancellare",
  "dialogs.discard.msg": "Sei sicuro di voler cancellare tutte le modifiche?",
  "dialogs.discard.title": "Cancellare modifiche",
  "dialogs.download_app_title": "Scaricare App",
  "dialogs.manage_tags": "Gestisci i tag",
  "dialogs.member": "Membro",
  "dialogs.members": "Membri: tutti i membri di ",
  "dialogs.move_items_title": "Sposta 1 elemento in... | Sposta {n} elementi in...",
  "dialogs.move_to_inbox": "Sposta nella Inbox",
  "dialogs.name": "Nome",
  "dialogs.newBox": "Nuova box",
  "dialogs.no": "No",
  "dialogs.node_create_new.error.create": "{fileName} non può essere creato",
  "dialogs.node_create_new.success.create": "{fileName} creato con successo",
  "dialogs.node_create_new.title": "Creare nuovo {file} file",
  "dialogs.remove_deadline": "Rimuovere la scadenza",
  "dialogs.rename": "Rinominare",
  "dialogs.save": "Salva",
  "dialogs.select_location": "Selezionare la posizione",
  "dialogs.session_invalid.btn_login": "Login",
  "dialogs.session_invalid.loggedout.msg": "Sei stato disconnesso da DeepBox. Effettuare nuovamente il login.",
  "dialogs.session_invalid.loggedout.title": "Sei stato disconnesso da DeepBox",
  "dialogs.session_invalid.session_expired.msg": "Per motivi di sicurezza è stato effettuato il logout da DeepBox. Effettuare nuovamente il login.",
  "dialogs.session_invalid.session_expired.title": "Sei stato disconnesso da DeepBox",
  "dialogs.tags.most_used_tags": "Proposta",
  "dialogs.tags.n_selected": "1 selezionato | {n} selezionato",
  "dialogs.tags.title": "Tags",
  "dialogs.tags.toast.success.n_updated": "1 file è stato aggiornato con successo | {n}  file è stato aggiornato con successo",
  "dialogs.yes": "Sì",
  "drag_drop.msg.error.missing_permissions_to_add_children": "Manca l'autorizzazione ad aggiungere file",
  "drag_drop.msg.error.missing_permissions_to_delete_some_nodes": "1 elemento non può essere eliminato perché non si ha l'autorizzazione per farlo. Questo elemento sarà filtrato. | Gli elementi {n} non possono essere cancellati perché non si ha il permesso di farlo. Questo elemento sarà filtrato.",
  "drag_drop.msg.error.move_to_same_parent": "Il file non può essere spostato perché è stata selezionata la cartella di origine. | I file non possono essere spostati perché è stata selezionata la cartella di origine.",
  "drag_drop.msg.error.target_is_one_of_the_nodes_to_be_moved": "La cartella non può essere spostata su se stessa",
  "drag_drop.msg.success.node_moved_to_target": "L'elemento è stato spostato con successo nella seguente cartella: \"{targetName}\" | Gli elementi sono stati spostati con successo nella seguente cartella: \"{targetName}\"",
  "error.403.box_elevated_auth_required.btn_2fa": "Attiva 2FA",
  "error.403.box_elevated_auth_required.description": "L'accesso richiede l'autenticazione a due fattori (2FA). Attiva la 2FA per poter accedere al contenuto condiviso.",
  "error.403.box_elevated_auth_required.link_2fa_info": "Altre informazioni su 2FA",
  "error.403.box_elevated_auth_required.title": "Accesso negato",
  "error.403.box_not_found_or_no_access": "Box non esiste o non hai il permesso di accedere al Box.",
  "error.403.file": "Non hai il permesso di accedere al documento.",
  "error.403.file_not_found_or_no_access": "Il file non esiste o non hai il permesso di accedere al documento.",
  "error.403.settings": "Non siete autorizzati ad accedere a queste impostazioni.",
  "error.403.wrong_account_email": "L'e-mail dell'account con cui si sta cercando di firmare questo documento non corrisponde a quella a cui è stata inviata la richiesta di firma. Effettuare il logout e riaprire il link ricevuto via e-mail.",
  "error.413.file_too_big": "File troppo grande",
  "error.axios.ERR_NETWORK": "La connessione è stata interrotta",
  "error.code": "Codice",
  "error.codes.ERR_FILE_NOT_FOUND": "File non trovato",
  "error.codes.KC_ERROR_UPDATE_TOKEN": "Sessione non valida",
  "error.codes.UPLOAD_PARENT_NODE_ID_CAN_NOT_BE_EMPTY": "L'ID del nodo genitore non può essere vuoto",
  "error.download.multiple.n_max_length": "È possibile scaricare contemporaneamente un massimo di {n} elementi selezionati.",
  "error.download.not_possible": "Impossibile scaricare",
  "error.email_do_not_match.description": "Stai creando un account con l'email <b>{newEmail}</b>,  ma è ancora collegato alla seguente email: <b>{currentEmail}</b> .\n<br />\nEsci per creare un account con un nuovo indirizzo e-mail.",
  "error.email_do_not_match.title": "L'email non corrisponde",
  "error.error_occurred": "Si è verificato un errore",
  "error.home": "Home",
  "error.inbox.folders_are_not_allowed": "Le cartelle non sono supportate nella Posta in arrivo. 1 La cartella non viene spostata. | Le cartelle non sono supportate nella Posta in arrivo. {n} non vengono spostate.",
  "error.invalid_or_missing_params": "Parametri non validi o mancanti",
  "error.invalid_param_email": "Parametri e-mail non validi",
  "error.invalid_password": "Password non valida",
  "error.invalid_url_service_param": "Param del servizio url non valido",
  "error.key_invalid_or_expired": "Key non è valido o è scaduto",
  "error.logged_out": "Siete stato disconnesso",
  "error.login": "Tornare al login",
  "error.organization_not_found": "Organizzazione non trovata",
  "error.page_not_found": "Pagina non trovata",
  "error.page_not_found_or_missing_permissions": "Pagina non trovata o non hai i permessi per accedere a questa risorsa.",
  "error.url_invalid": "L’URL non è valido o è scaduto",
  "error.validation.invalid": "Per favore, controlla il tuo inserimento",
  "external_services.aba_ninja.description": "Collegare il programma di contabilità",
  "external_services.deepmail.description": "Inviare Deep Mail",
  "external_services.hoop.description": "Costituire e modificare digitalmente aziende",
  "external_services.title": "Applicazioni abilitate da DeepBox",
  "fields.country_select.label": "Scegliere paese",
  "fields.errors.invalid_email": "L'indirizzo E-Mail non è valevole",
  "fields.errors.invalid_password": "La password non è conforme alle regole di convalida",
  "fields.errors.max_length": "La lunghezza massima di {maxLength} è stata superata",
  "fields.errors.min_length": "La lunghezza minima di {minLength} non è stata raggiunta",
  "fields.errors.required": "Campo obbligatorio",
  "fields.multi_language_text.btn_add": "Aggiungi lingua",
  "fields.multi_language_text.field_key_label": "Lingua",
  "fields.multi_language_text.field_value_label": "Testo",
  "fields.password.label": "Password",
  "fields.password_with_verification.hint": "Almeno {counter} caratteri (lettere, numeri e simboli)",
  "fields.phone.placeholder": "Inserire il numero di telefono",
  "fields.search_for_boxes.placeholder": "Ricerca Box",
  "fields.uid.label": "IDI",
  "fields.uid.placeholder.country.ch": "Es: {example}",
  "fields.uid.placeholder.country.row": "Inserire IDI",
  "fields.zip_city.city.label": "Luogo",
  "fields.zip_city.zip.label": "CAP",
  "form.de": "Tedesco",
  "form.email": "e-mail",
  "form.en": "Inglese",
  "form.extension": "Estensione",
  "form.fr": "Francese",
  "form.it": "Italiano",
  "form.manage_translations": "Gestire le traduzioni",
  "form.message": "messaggio",
  "form.name": "Nome",
  "form.noDataText": "Nessun dato disponibile",
  "form.type": "Tipo",
  "hints.analysis.failed": "Analisi fallita",
  "hints.analysis.running": "Analisi in corso...",
  "hints.expired": "È scaduto",
  "hints.expires": "Scade",
  "hints.n_files": "1 file | {n} file",
  "hints.n_folders": "1 cartella | {n} cartelle",
  "inbox_address.btn_generate": "Genera nuovo indirizzo",
  "inbox_address.delete.msg": "Sei sicuro di voler cancellare questo indirizzo?",
  "inbox_address.delete.title": "Cancella indirizzo",
  "inbox_address.delete_address": "Cancella indirizzo",
  "inbox_address.description": "Genera indirizzi unici attraverso i quali i documenti possono essere inviati direttamente a te tramite un'e-mail o un dialogo di caricamento nella Posta in arrivo. Chiunque abbia accesso a questi indirizzi può inviarti dei file. Fai quindi attenzione con chi li condividi. Gli indirizzi possono essere disattivati in qualsiasi momento. {link}",
  "inbox_address.description_short": "Genera indirizzi univoci che possono essere utilizzati per inviare i documenti direttamente alla tua inbox tramite un'e-mail o dialogo di caricamento... {link}",
  "inbox_address.edit.label.description": "Descrizione",
  "inbox_address.edit.label.email_link": "Collegamento e-mail",
  "inbox_address.edit.label.upload_link": "Link di caricamento",
  "inbox_address.manage_all_addresses": "Gestire gli indirizzi",
  "inbox_address.title": "Indirizzo per questa inbox",
  "inbox_address.toast.error.email_disabled": "Non è stato possibile disattivare il link di caricamento",
  "inbox_address.toast.error.email_enabled": "Non è stato possibile attivare il link di caricamento",
  "inbox_address.toast.error.upload_disabled": "Non è stato possibile disattivare il link all'e-mail",
  "inbox_address.toast.error.upload_enabled": "Non è stato possibile attivare il link per l'e-mail",
  "inbox_address.toast.success.email_disabled": "Il link all'e-mail è stato disattivato con successo",
  "inbox_address.toast.success.email_enabled": "Il link all'e-mail è stato attivato con successo",
  "inbox_address.toast.success.generated": "L'indirizzo è stato generato con successo",
  "inbox_address.toast.success.saved": "L'indirizzo salvato con successo",
  "inbox_address.toast.success.upload_disabled": "Il link di caricamento è stato disattivato con successo",
  "inbox_address.toast.success.upload_enabled": "Il link di caricamento è stato attivato con successo",
  "labels.attachments": "Allegati",
  "labels.boxes_shared_with_me": "Condiviso con me",
  "labels.clear_all": "Rimuovi tutto",
  "labels.description": "Descrizione",
  "labels.documents_in_inbox": "Documento nell'inbox | Documenti nell'inbox",
  "labels.email": "E-mail",
  "labels.favorite": "Preferito",
  "labels.favorites": "Preferiti",
  "labels.file": "File | File",
  "labels.files": "File | File",
  "labels.filter": "Filtro",
  "labels.folder": "Cartella | Cartelle",
  "labels.insufficient_permissions": "Permessi insufficienti",
  "labels.less": "meno",
  "labels.load_more": "Caricare altro",
  "labels.menu.actions.favorites.add": "Aggiungi ai preferiti",
  "labels.menu.actions.favorites.remove": "Rimuovi dai preferiti",
  "labels.more": "di più.",
  "labels.n_elements_selected": "1 elemento selezionato | {n} elementi selezionati",
  "labels.open": "Apri",
  "labels.open_dashboard": "Apri il Dashboard",
  "labels.others": "altro | altri",
  "labels.recents": "Recenti",
  "labels.request_message": "Richiesta di supporto",
  "labels.section": "Sezione",
  "labels.show_all": "Mostra tutto",
  "labels.show_less": "Mostra meno",
  "labels.show_more": "Mostra di più",
  "labels.suggestions": "Suggerimenti",
  "labels.valid_from": "Valido dal",
  "labels.valid_until": "Valido fino al",
  "links.read_more": "Maggiori informazioni",
  "loader.files.are_being_indexed": "I file vengono indicizzati...",
  "loader.is_loading": "Caricamento...",
  "main_view.all": "Mostra tutto",
  "main_view.boxes_shared_with_me": "Box condivise con me",
  "main_view.deadlines": "Scadenze",
  "main_view.favorites": "Preferiti",
  "main_view.inbox": "Inbox",
  "main_view.recents": "Recenti",
  "main_view.search_for_boxes": "Ricerca Box",
  "messages.error.deepsign_file_max_size": "Solo i file fino a una dimensione di {size} possono essere firmati.",
  "messages.error.deepvalidator_file_max_size": "Solo i file fino a una dimensione di {size} possono essere aperti con DeepValidator.",
  "messages.error.file_size": "Solo i file fino a una dimensione di 2 GB possono essere caricati.",
  "messages.no_box_found": "Non è stata trovata alcuna Box.",
  "messages.no_boxes_found": "Nessuna box trovata",
  "messages.no_boxes_found_title": "Nessuna box",
  "messages.success.box_created": "Box creata con successo",
  "messages.success.copy_of": "Copia di {fileName} creata con successo | Copia dei file di {n} creata con successo",
  "messages.success.delete": "1 file spostato nel cestino | {n} file spostato nel cestino",
  "messages.success.delete_permanently": "1 file eliminato in modo permanente | {n} file eliminato in modo permanente",
  "messages.success.file_converted_to_pdf": "File {fileName} creato con successo | {n} file PDF creati con successo",
  "messages.success.file_upload": "Nessun documento è stato caricato su {destination} | {number} documento è stato caricato su {destination} | {number} documenti sono stati caricati su {destination}",
  "messages.success.folder_created": "La cartella {name} è stata creata con successo.",
  "messages.success.folder_upload": "La cartella {destination} è stata creata .  |  È stata creata una cartella {destination} e sono stati caricati {number} documento in essa | È stata creata una cartella {destination} e sono stati caricati {number} documenti in essa.",
  "messages.success.move": "Nessun elemento è stato spostato a {destination} | {n} elemento è stato spostato verso {destination} | {n} elementi sono stati spostati su {destination}",
  "messages.success.move_to_box_element": "Nessun elemento è stato spostato nella cartella \"{folderName}\" del box \"{boxName}\" | {n} elemento è stato spostato nella cartella \"{folderName}\" del box \"{boxName}\" | {n} elementi spostati nella cartella \"{folderName}\" del box \"{boxName}\"",
  "messages.success.move_to_box_file": "Nessun file è stato spostato nella cartella \"{folderName}\" del box \"{boxName}\" | {n} file è stato spostato nella cartella \"{folderName}\" del box \"{boxName}\" | {n} file sono stati spostati nella cartella \"{folderName}\" del box \"{boxName}\"",
  "messages.success.restore": "1 file ripristinati con successo | {n} file ripristinati con successo",
  "msgbox.btn_agree": "Confermare",
  "msgbox.btn_cancel": "Annullare",
  "msgbox.checkbox.validation.required": "Campo richiesto",
  "navigation.collapse": "Comprimi",
  "navigation.dashboard": "Dashboard",
  "navigation.deepbox_settings": "Impostazioni di Box",
  "navigation.deepo_settings": "Impostazioni di DeepO",
  "navigation.expand": "Espandi",
  "navigation.of": "{currentFile} di {filesNumber}",
  "navigation.recent": "Recenti",
  "navigation.recent_boxes": "Recenti boxes",
  "navigation.tabs.all": "Tutte le box",
  "navigation.tabs.favorites": "Preferiti",
  "navigation.tabs.files": "Documenti",
  "navigation.tabs.inbox": "Inbox",
  "navigation.tabs.recent": "Recenti",
  "navigation.tabs.trash": "Cestino",
  "no_box.box_name": "Box della mia azienda",
  "no_box.button_text": "Crea la tua DeepBox",
  "no_box.features.automate_document_processing": "Elaborazione automatica dei documenti",
  "no_box.features.connect": "Connettersi con terze parti",
  "no_box.features.share_documents": "Condividere documenti con altri",
  "no_box.features.store_your_documents": "Memorizza i tuoi documenti",
  "no_box.title": "Samplecompany SA",
  "node.cloudoffice.msg_box.terms.member.content": "Il servizio Microsoft 365 web non è ancora stato abilitato dalla vostra organizzazione. {link}",
  "node.cloudoffice.msg_box.terms.member.title": "Non sbloccato",
  "node.cloudoffice.msg_box.terms.owner.checkbox.label": "Accetto i termini.",
  "node.cloudoffice.msg_box.terms.owner.content": "Per la gestione dei file, utilizzate un servizio Microsoft. Si prega di confermare che accettate i termini di utilizzo di Microsoft e la loro politica sulla privacy. Inoltre, si applicano i termini di utilizzo della DeepCloud REST API.",
  "node.cloudoffice.msg_box.terms.owner.title": "Microsoft 365 web",
  "node.download.errors.av_scan_file_too_big.btn.agree": "Scaricare comunque",
  "node.download.errors.av_scan_file_too_big.checkbox.label": "Capisco i rischi e vorrei comunque scaricare il/i file | Capisco i rischi e vorrei comunque scaricare il/i file",
  "node.download.errors.av_scan_file_too_big.message": "Il file non può essere controllato per i virus perché è troppo grande. <br />\nIl file potrebbe essere dannoso, quindi scaricalo solo se comprendi i rischi. | Almeno un file non ha potuto essere controllato per i virus perché è troppo grande. <br />\nIl file potrebbe essere dannoso, quindi lo scarichi solo se comprende i rischi.",
  "node.download.errors.av_scan_file_too_big.title": "Scansione virus fallita",
  "node.download.errors.av_scan_virus_found.btn.agree": "Scaricare comunque",
  "node.download.errors.av_scan_virus_found.checkbox.label": "Capisco i rischi e vorrei comunque scaricare il/i file | Capisco i rischi e vorrei comunque scaricare il/i file",
  "node.download.errors.av_scan_virus_found.message": "Il nostro scanner di virus ha trovato un virus in questo file. <br />\nLe raccomandiamo di non scaricare i file perché potrebbero essere dannosi. | Il nostro antivirus ha trovato un virus in almeno un file. <br />\nLe raccomandiamo di non scaricare i file perché potrebbero essere dannosi.",
  "node.download.errors.av_scan_virus_found.title": "ATTENZIONE: Virus trovato",
  "node.download.errors.av_scan_virus_found_and_file_too_big.btn.agree": "Scaricare comunque",
  "node.download.errors.av_scan_virus_found_and_file_too_big.checkbox.label": "Comprendo i rischi e desidero comunque scaricare il file. | Capisco i rischi e vorrei comunque scaricare i file",
  "node.download.errors.av_scan_virus_found_and_file_too_big.message": "Il nostro antivirus ha trovato un virus in almeno un file o almeno un file non ha potuto essere controllato a causa delle sue dimensioni.<br />\nRaccomandiamo di non scaricare i file perché potrebbero essere dannosi.",
  "node.download.errors.av_scan_virus_found_and_file_too_big.title": "Attenzione!",
  "node.download.success": "Inizio del download",
  "node.download.zip_snackbar.generating_zip_file": "Creazione di file ZIP | Creazione di {n} file ZIP",
  "node.download.zip_snackbar.zip_download": "Scarica ZIP",
  "node.preview.errors.av_scan_file_too_big.btn.agree": "Mostra comunque",
  "node.preview.errors.av_scan_file_too_big.checkbox.label": "Comprendo i rischi e desidero visualizzare il file in ogni caso | Comprendo i rischi e desidero visualizzare i file in ogni caso",
  "node.preview.errors.av_scan_file_too_big.message": "Non è stato possibile controllare questo file per i virus perché è troppo grande.<br />\nIl file potrebbe essere dannoso, quindi visualizzatelo solo se ne conoscete i rischi.",
  "node.preview.errors.av_scan_file_too_big.title": "Scansione virus fallita",
  "node.preview.errors.av_scan_virus_found.btn.agree": "Mostra comunque",
  "node.preview.errors.av_scan_virus_found.checkbox.label": "Capisco i rischi e voglio comunque visualizzare il file",
  "node.preview.errors.av_scan_virus_found.message": "Il nostro scanner di virus ha trovato un virus in questo file.<br />\nIl file potrebbe essere dannoso, quindi visualizzatelo solo se ne conoscete i rischi.",
  "node.preview.errors.av_scan_virus_found.title": "ATTENZIONE: Virus trovato",
  "node.share_link.errors.av_scan_file_too_big.btn.agree": "Condividi comunque",
  "node.share_link.errors.av_scan_file_too_big.checkbox.label": "Capisco i rischi e vorrei comunque condividere il file | Capisco i rischi e vorrei comunque condividere i file",
  "node.share_link.errors.av_scan_file_too_big.message": "Il file non può essere controllato per i virus perché è troppo grande (<b>{fileSize}</b>).<br />\nIl file potrebbe essere dannoso, quindi condividilo solo se comprendi i rischi.",
  "node.share_link.errors.av_scan_file_too_big.title": "Scansione virus fallita",
  "node.virus.table.headers.file": "File",
  "node.virus.table.headers.virus_signature": "Firma del virus",
  "node_data_table.actions.add_deadline": "Aggiungere la scadenza",
  "node_data_table.actions.analyze": "Analizza",
  "node_data_table.actions.assign_tags": "Aggiungi tags",
  "node_data_table.actions.continue_deepsign": "Continua su DeepSign",
  "node_data_table.actions.convert_to_pdf": "Convertire in PDF",
  "node_data_table.actions.copy_of": "Creare una copia",
  "node_data_table.actions.deepa_chat": "Chatta con DeepA",
  "node_data_table.actions.deepmail": "Inviare con DeepMail",
  "node_data_table.actions.delete_permanently": "Cancella definitivamente",
  "node_data_table.actions.details_deepsign": "Vedi dettagli su DeepSign",
  "node_data_table.actions.download": "Scaricare",
  "node_data_table.actions.edit": "Modificare",
  "node_data_table.actions.edit_deadline": "Modificare la scadenza",
  "node_data_table.actions.edit_tags": "Modifica tags",
  "node_data_table.actions.flow_start": "Avvio del flow",
  "node_data_table.actions.group.actions": "Azioni",
  "node_data_table.actions.group.organize": "Organizzare",
  "node_data_table.actions.hidden": "Nascosto",
  "node_data_table.actions.move_to": "Sposta in",
  "node_data_table.actions.move_to_trash": "Spostarsi nella spazzatura",
  "node_data_table.actions.pay": "Paga",
  "node_data_table.actions.pdf_compare": "Confrontare i PDF",
  "node_data_table.actions.rename": "Rinomina",
  "node_data_table.actions.restore": "Ripristina",
  "node_data_table.actions.share_link": "Condividi link",
  "node_data_table.actions.show_details": "Mostra dettagli",
  "node_data_table.actions.sign": "Firmare con DeepSign",
  "node_data_table.actions.summarization": "Riassumere con DeepA",
  "node_data_table.headers.date": "Data",
  "node_data_table.headers.deleted.time": "Cancellato",
  "node_data_table.headers.deleted.user": "Soppresso da",
  "node_data_table.headers.document_type": "Tipo",
  "node_data_table.headers.location": "Posizione",
  "node_data_table.headers.modified": "Modificato",
  "node_data_table.headers.name": "Nome",
  "node_data_table.headers.owner": "Proprietario",
  "node_data_table.headers.received": "Ricezione",
  "node_data_table.headers.retained_until": "Conservato fino al",
  "node_data_table.headers.signature": "Firma",
  "node_data_table.headers.size": "Dimensione",
  "node_data_table.headers.timestamp": "Marca temporale",
  "node_data_table.me": "Io",
  "node_data_table.mobile.sort_keys.largest": "Più grande",
  "node_data_table.mobile.sort_keys.name_asc": "Nome crescente",
  "node_data_table.mobile.sort_keys.name_desc": "Nome decrescente",
  "node_data_table.mobile.sort_keys.newest": "Più recente",
  "node_data_table.mobile.sort_keys.oldest": "Più vecchio",
  "node_data_table.mobile.sort_keys.smallest": "Più piccolo",
  "node_data_table.sign": "Firmare",
  "node_data_table.tags": "Tags",
  "node_data_table.tags_multiple": "Tag multipli",
  "node_data_table.tooltip.comment": "Commento",
  "node_data_table.tooltip.comments_show": "Mostra commenti",
  "node_data_table.tooltip.sign_status_pending": "Firma(e) in attesa",
  "node_data_table.tooltip.sign_status_signed": "Completamente firmato",
  "node_data_table.views.hidden": "Mostra elementi nascosti",
  "node_data_table.views.list": "Lista grande",
  "node_data_table.views.list_dense": "Lista",
  "nodes.convert_to_pdf_and_sign_msg_box.checkbox.label": "Non mostrare più",
  "nodes.convert_to_pdf_and_sign_msg_box.errors.file_to_big_mb": "Il file è troppo grande. La dimensione massima del file è di {maxFileSize} MB",
  "nodes.convert_to_pdf_and_sign_msg_box.msg": "Una copia PDF del file viene creata per la firma con DeepSign e memorizzata nella stessa posizione della DeepBox.",
  "nodes.convert_to_pdf_and_sign_msg_box.msg_converting_file_to_pdf": "Il file verrà convertito in PDF",
  "nodes.convert_to_pdf_and_sign_msg_box.title": "Viene creato il PDF per la firma",
  "nodes.files_description_types.audio": "audio",
  "nodes.files_description_types.document": "documento",
  "nodes.files_description_types.file": "file",
  "nodes.files_description_types.image": "immagine",
  "nodes.files_description_types.video": "video",
  "nodes.upload_card.labels.count_error": "1 fallito | {n} fallito",
  "nodes.upload_card.labels.count_n_of_total": "{n} di {total} Elementi",
  "nodes.upload_card.title": "Caricamenti",
  "onlyoffice.editor.open_file_location": "Aprire la posizione del file",
  "overlays.overused_subscription.has_a_blocking_amount_of_open_invoices.admin_or_member.actions.support": "DeepCloud",
  "overlays.overused_subscription.has_a_blocking_amount_of_open_invoices.admin_or_member.text": "Esistono diversi conti in sospeso da pagare. Per questo motivo, il conto è stato bloccato. Si prega di contattare l'amministratore per sbloccare il conto.",
  "overlays.overused_subscription.has_a_blocking_amount_of_open_invoices.owner.actions.open_invoices": "Tra le fatture",
  "overlays.overused_subscription.has_a_blocking_amount_of_open_invoices.owner.text": "Esistono diversi conti in sospeso che devono essere saldati. Per questo motivo, l'account è stato bloccato. Si prega di saldare i conti in sospeso per sbloccare l'account.",
  "overlays.overused_subscription.has_a_blocking_amount_of_open_invoices.title": "Pagamenti in sospeso",
  "overlays.overused_subscription.has_overused_box_users.admin_or_member.text": "Il tuo DeepBox ha troppi utenti o troppi box in uso rispetto a quello che è attualmente disponibile attraverso il tuo abbonamento. Per favore, informa un proprietario di questo DeepBox in modo che possa aggiustare l'abbonamento.",
  "overlays.overused_subscription.has_overused_box_users.owner.actions.manage_organization": "Gestire l'organizzazione",
  "overlays.overused_subscription.has_overused_box_users.owner.actions.manage_subscription": "Gestire l'abbonamento",
  "overlays.overused_subscription.has_overused_box_users.owner.text": "Il tuo DeepBox ha troppi utenti o troppi box in uso rispetto a quello che è attualmente disponibile attraverso il tuo abbonamento. Per favore, attiva l'abbonamento corrispondente per questo DeepBox o rimuovi gli utenti o i box.",
  "overlays.overused_subscription.has_overused_box_users.title": "È necessario attivare un abbonamento per poter continuare a utilizzare questo DeepBox.",
  "overlays.overused_subscription.learn_more": "Per saperne di più sugli abbonamenti DeepBox: ",
  "overlays.overused_subscription.title": "Abbonamento",
  "page_titles.search_results": "Risultati della ricerca",
  "pages.dashboard.deadlines": "Scadenze",
  "pages.dashboard.empty.text": "Le tue Box verranno visualizzate qui",
  "pages.dashboard.empty.text_can_not_onboard": "Non hai i permessi necessari per creare un box. <br />\nContatta un proprietario o un amministratore della tua organizzazione.",
  "pages.dashboard.empty.text_create_box": "Crea gratuitamente il tuo primo box per utilizzare la piattaforma svizzera all-in-one per lo scambio sicuro di documenti.",
  "pages.dashboard.empty.title": "Nessuna Box disponibile",
  "pages.dashboard.inbox": "Inbox",
  "pages.dashboard.labels.all_sections": "Tutte le sezioni",
  "pages.dashboard.labels.display_all_n": "Mostra tutti ({n})",
  "pages.dashboard.labels.tabs": "Tabs",
  "pages.dashboard.onboarding.banner.actions.continue": "Proseguire con l'onboarding",
  "pages.dashboard.onboarding.banner.text_in_progress": "Per utilizzare il DeepBox, è necessario completare il processo di onboarding.",
  "pages.dashboard.onboarding.banner.text_not_started": "Per utilizzare DeepBox da solo, devi completare il tuo account.",
  "pages.dashboard.private_box_title": "Per voi",
  "pages.links.alert_info": "Questo link scadrà tra 1 giorno | Questo link scadrà tra {n} giorni",
  "pages.links.alert_msg_date_expired": "Il link è scaduto",
  "pages.links.btn_download": "Scaricare",
  "pages.links.btn_view": "Vedi",
  "pages.links.file_preview_not_available": "Il file non può essere visualizzato in anteprima.",
  "pages.store.services.aba_ninja.category": "Contabilità",
  "pages.store.services.aba_ninja.content": "<div>\nDeepNinja è il programma di contabilità che ti permette di gestire facilmente le finanze della tua azienda. Lo strumento efficiente per le offerte, le fatture, i pagamenti, la registrazione ore e molto altro ancora, ti supporta nelle attività amministrative. Grazie alla nuova connessione DeepBox/DeepNinja, i documenti possono essere facilmente scambiati e poi elaborati automaticamente direttamente con il programma di contabilità.\n</div>\n<br />\n<div>\nQui puoi aprire direttamente un account DeepNinja e collegarlo al tuo DeepBox.\n</div>\n<div class=\"mt-4\">I tuoi vantaggi:</div>\n<ul>\n  <li>Creazione di offerte e fatture e archiviazione in DeepBox</li>\n  <li>Elaborazione automatica delle fatture dei fornitori con DeepBox</li>\n  <li>Inserimento semplice di orari e servizi</li>\n  <li>Collegamento diretto alla contabilità finanziaria di Abacus ERP</li>\n</ul>",
  "pages.store.services.aba_ninja.languages": "Tedesco, francese, italiano, inglese",
  "pages.store.services.aba_ninja.price": "CHF 21.- al mese",
  "pages.store.services.aba_ninja.subtitle": "Programma di contabilità",
  "pages.store.services.aba_ninja.title": "DeepNinja",
  "pages.store.services.hoop.category": "Costituzione",
  "pages.store.services.hoop.content": "<div>\nHoop è un'applicazione che semplifica la creazione di aziende in formato digitale. Dall'inserimento dei dati di fondazione alla creazione di un conto per il versamento del capitale della società fino all'iscrizione al Registro di commercio, questo processo copre tutte le fasi di costituzione di una società.\n</div>\n<div class=\"mt-4\">I tuoi vantaggi:</div>\n<ul>\n  <li>Processo semplice e 100% digitale</li>\n  <li>Apertura digitale di un conto per il versamento del capitale</li>\n  <li>Certificazione notarile con firma digitale integrata</li>\n  <li>Tutti i documenti sono archiviati centralmente nel DeepBox</li>.\n</ul>\n<div class=\"mt-4\">Possibili forme giuridiche:</div>\n<ul>\n<li>Ditta individuale</li>\n  <li>Società a garanzia limitata (Sagl)</li>\n  <li>Società anonima (SA)</li>\n</ul>",
  "pages.store.services.hoop.languages": "Tedesco, francese, italiano, inglese",
  "pages.store.services.hoop.links.contact": "Contattaci",
  "pages.store.services.hoop.links.title": "Hoop Corporation Services SA",
  "pages.store.services.hoop.links.website": "Sito web",
  "pages.store.services.hoop.price": "Prezzo unico CHF 490.-",
  "pages.store.services.hoop.subtitle": "Processo di costituzioni societarie digitale",
  "pages.store.services.hoop.title": "Hoop - Costituzione di società",
  "pages.upload.add_more_files": "Aggiungi altri file",
  "pages.upload.dialog_unsupported_files.text": "Ha 1 file non supportato.\nQuesto file non verrà caricato.\n| Ha {n} file non supportati.\nQuesti file non verranno caricati.",
  "pages.upload.dialog_unsupported_files.title": "File non supportati",
  "pages.upload.errors.invalid_url": "La pagina di caricamento non è valida. Contatti un amministratore di questa DeepBox. ",
  "pages.upload.errors.not_found": "Non è stato possibile caricare i file. Ricarica la pagina.",
  "pages.upload.errors.upload_failed": "Alcuni file non sono stati caricati. Riprovare.",
  "pages.upload.text_intro": "Con il caricamento diretto puoi inviare i file direttamente alla Box {box} di {organization}.",
  "pages.upload.text_link_validity": "Il link di caricamento scadrà tra {n}.",
  "pages.upload.title": "Carica i file",
  "pages.upload.upload_error": "1 file non è stato caricato | {n} file non sono stati caricati",
  "pages.upload.upload_success": "1 file è stato caricato con successo | {n} file sono stati caricati con successo",
  "placeholders.enter_support_request": "Inserisci qui la descrizione della tua richiesta...",
  "placeholders.filter_by_owner": "Filtra per proprietario",
  "placeholders.filter_by_tags": "Filtrare per tag",
  "placeholders.search": "Cercare…",
  "placeholders.search_box": "Cercare una box...",
  "placeholders.search_in_box": "Cerca in {box} ",
  "placeholders.search_tags": "Cerca tag...",
  "placeholders.select": "Selezionare",
  "pocs.deep_docs.box.filters.changed_by_me.title": "Modificato da me",
  "pocs.deep_docs.box.filters.favorites.title": "Favoriti",
  "pocs.deep_docs.box.filters.flow.title": "In Flow",
  "pocs.deep_docs.box.filters.recents.title": "Recenti",
  "pocs.deep_docs.box.group_by.assignee.title": "Assegnato",
  "pocs.deep_docs.box.group_by.document_type.title": "Tipo di documento",
  "pocs.deep_docs.box.group_by.flow.title": "Flow",
  "pocs.deep_docs.box.group_by.none.title": "Nessuna",
  "pocs.deep_docs.box.group_by.owner.title": "Proprietario",
  "pocs.deep_docs.box.group_by.project.title": "Progetto",
  "pocs.deep_docs.box.group_by.type.title": "Tipo",
  "pocs.deep_docs.node_actions.copy.toast_messages.success": "Copia di {fileName} creata con successo | Copia dei file di {n} creata con successo",
  "pocs.deep_docs.node_actions.download.toast.preparing_download": "Il vostro download sta per essere preparato...",
  "pocs.deep_docs.node_actions.move_to.toast_messages.readonly_folders": "Gli elementi con autorizzazione di sola lettura non possono essere spostati.",
  "pocs.deep_docs.node_actions.move_to.toast_messages.successfully_moved": "Elementi spostati con successo",
  "pocs.deep_docs.node_actions.move_to_inbox.errors.no_permission": "Nessuna autorizzazione per l'inbox",
  "pocs.deep_docs.node_actions.move_to_inbox.toast_messages.successfully_moved": "Elementi spostati con successo nell'inbox",
  "pocs.deep_docs.node_details.attributes.assign_to_me": "Assegna a me",
  "pocs.deep_docs.pages.assigned.subtitle": "Documenti in attesa della vostra azione.",
  "pocs.deep_docs.pages.assigned.title": "Assegnato a me",
  "pocs.deep_docs.pages.dashboard.subtitle": "Questo sta accadendo proprio nel vostro ambiente di lavoro.",
  "pocs.deep_docs.pages.dashboard.title": "Dashboard",
  "pocs.deep_docs.pages.favorites.subtitle": "I suoi documenti preferiti.",
  "pocs.deep_docs.pages.favorites.title": "Preferiti",
  "pocs.deep_docs.pages.inbox.subtitle": "Nuovi documenti in arrivo.",
  "pocs.deep_docs.pages.inbox.title": "Inbox",
  "pocs.deep_docs.pages.recents.subtitle": "Ultimi documenti aggiornati.",
  "pocs.deep_docs.pages.recents.title": "Ultimamente",
  "pocs.deep_docs.pages.trash.subtitle": "Documenti eliminati.",
  "pocs.deep_docs.pages.trash.title": "Cestino",
  "preview.analyse.btn_action": "Analizza",
  "preview.analyse.loader_is_being_analysed": "Il documento viene analizzato",
  "preview.analyse.text": "Questo documento non è ancora stato analizzato.",
  "preview.analyse.toaster.success": "Il documento è stato analizzato",
  "preview.cant_be_previewed": "Il file non può essere visualizzato in anteprima.",
  "preview.dialog.password.text": "Inserire la password del file",
  "preview.dialog.password.text_retry": "Inserire nuovamente la password del file",
  "preview.dialog.password.title": "File criptati",
  "preview.node_actions.text_download": "Scaricare",
  "preview.node_actions.text_pages": "{currentPage} di {totalPages} pagine",
  "preview.node_actions.text_print": "Stampa",
  "preview.not_available": "Nessuna anteprima disponibile",
  "preview.rendering": "Rendering in corso...",
  "preview.toaster.error.document_loading_failed": "Si è verificato un errore durante il caricamento del documento. La preghiamo di riprovare più tardi.",
  "search.advanced": "Avanzato...",
  "search.current": "Posizione corrente - {location}",
  "search.enter_some_text": "Inserite del testo nel campo di ricerca...",
  "search.everywhere": "Ovunque -  {location}",
  "search.in": "In",
  "search.instructions.lede": "Digitare uno o più termini è sufficiente per una ricerca semplice, i file più pertinenti compaiono per primi. Per ricerche più mirate, è possibile combinare gli operatori qui sotto.",
  "search.instructions.note.tip1": "Maiuscole e minuscole nei termini di ricerca non contano, <b>rapporto</b> trova anche <b>Rapporto</b>.",
  "search.instructions.note.tip2": "Un numero maggiore di termini porta a più risultati potenziali. I risultati più pertinenti compaiono comunque per primi.",
  "search.instructions.section1.description": "Più parole ampliano la ricerca. I file che contengono tutti i termini vengono automaticamente classificati più in alto.",
  "search.instructions.section1.example1.description": "Tutti i file che contengono <b>rapporto</b>.",
  "search.instructions.section1.example1.query": "rapporto",
  "search.instructions.section1.example2.description": "<b>rapporto</b> o <b>budget</b>, i risultati con entrambi i termini compaiono in cima.",
  "search.instructions.section1.example2.query": "rapporto budget",
  "search.instructions.section1.example3.description": "Solo la sequenza esatta <b>rapporto annuale 2024</b>.",
  "search.instructions.section1.example3.query": "\"rapporto annuale 2024\"",
  "search.instructions.section1.example4.description": "<b>contratto</b> o la frase <b>rapporto annuale 2024</b>.",
  "search.instructions.section1.example4.query": "contratto \"rapporto annuale 2024\"",
  "search.instructions.section1.title": "Ricerca per termini",
  "search.instructions.section2.description": "Un + anteposto rende un termine obbligatorio, un − lo esclude.",
  "search.instructions.section2.example1.description": "Deve contenere <b>rapporto</b>, <b>budget</b> è opzionale.",
  "search.instructions.section2.example1.query": "+rapporto budget",
  "search.instructions.section2.example2.description": "<b>rapporto</b>, ma senza <b>bozza</b>.",
  "search.instructions.section2.example2.query": "rapporto -bozza",
  "search.instructions.section2.example3.description": "Deve contenere entrambi i termini.",
  "search.instructions.section2.example3.query": "+rapporto +budget",
  "search.instructions.section2.example4.description": "Frase <b>rapporto annuale 2024</b>, senza <b>bozza</b>.",
  "search.instructions.section2.example4.query": "\"rapporto annuale 2024\" -bozza",
  "search.instructions.section2.title": "Criteri obbligatori e di esclusione",
  "search.instructions.section3.description": "Gli operatori vanno scritti in maiuscolo. Le parentesi raggruppano le condizioni correlate.",
  "search.instructions.section3.example1.description": "Deve contenere entrambi i termini.",
  "search.instructions.section3.example1.query": "rapporto AND budget",
  "search.instructions.section3.example2.description": "Almeno uno dei due termini.",
  "search.instructions.section3.example2.query": "fattura OR ricevuta",
  "search.instructions.section3.example3.description": "<b>rapporto</b>, ma senza <b>bozza</b>.",
  "search.instructions.section3.example3.query": "rapporto NOT bozza",
  "search.instructions.section3.example4.description": "(<b>fattura</b> o <b>ricevuta</b>) e <b>2024</b>.",
  "search.instructions.section3.example4.query": "(fattura OR ricevuta) AND 2024",
  "search.instructions.section3.example5.description": "<b>rapporto</b> e una delle due frasi.",
  "search.instructions.section3.example5.query": "rapporto AND (\"Q3 2024\" OR \"Q4 2024\")",
  "search.instructions.section3.title": "Combinare con AND, OR, NOT",
  "search.instructions.title": "Aiuto per la ricerca",
  "search.location": "Posizione",
  "search.modified": "Modificato",
  "search.modified_14d": "14 giorni fa",
  "search.modified_1h": "1 ora fa",
  "search.modified_24h": "24 ore fa",
  "search.modified_30d": "30 giorni fa",
  "search.modified_7d": "7 giorni fa",
  "search.modified_pick_date": "Scegli una data…",
  "search.modified_range_last_12m": "Ultimi 12 mesi",
  "search.modified_range_last_30d": "Ultimi 30 giorni",
  "search.modified_range_last_3m": "Ultimi 3 mesi",
  "search.modified_range_last_7d": "Ultimi 7 giorni",
  "search.modified_range_month_to_date": "Questo mese",
  "search.modified_range_today": "Oggi",
  "search.modified_range_year_to_date": "Quest'anno",
  "search.more_locations": "Altre Sedi",
  "search.no_results": "Nessun risultato",
  "search.no_results_title": "Nessun elemento trovato",
  "search.no_results_title_location": "Nessun elemento trovato in {location}",
  "search.owner": "Proprietario",
  "search.results_found": "Nessun risultato per \"{searchTerm}\" | {n} risultato di ricerca per \"{searchTerm}\"  | {n} risultati di ricerca per \"{searchTerm}\"",
  "search.search_everywhere_link": "Cerca ovunque",
  "search.select_location": "Selezionare la posizione...",
  "search.tags": "Tags",
  "search.title": "Risultati della ricerca",
  "seo.description": "Modifica efficace e collaborativa dei tuoi documenti. Archiviazione e condivisione sicura dei documenti con il tuo computer o dispositivo mobile.",
  "services.download.snackbar.generate_in_progress": "Generando un file zip...",
  "services.download.snackbar.generate_success": "Zip creato. Sta scaricando...",
  "store.app_bar.btn_cancel": "Annullare",
  "store.app_bar.title": "Applicazione abilitata su DeepBox",
  "store.services.container.bottom.category": "Categoria",
  "store.services.container.bottom.languages": "Lingue",
  "store.services.container.bottom.price": "Prezzo",
  "test.weblate": "Test weblate source code",
  "toast.box.favorites.success_added": "La Box \"{boxName}\" è stata aggiunta con successo dai preferiti.",
  "toast.box.favorites.success_removed": "La Box \"{boxName}\" è stata rimossa con successo dai preferiti.",
  "toast.error.copy_value": "Non è stato possibile copiare il valore",
  "toast.success.copy_value": "Il valore è stato copiato con successo",
  "tooltip.icons.copy": "Copiare",
  "tooltip.icons.deepa_chat": "DeepA Chat",
  "tooltip.icons.deepadmin_profile": "Gestione DeepBox",
  "tooltip.icons.delete": "Cancella",
  "tooltip.icons.delete_all": "Elimina tutto",
  "tooltip.icons.details_panel": "Elenco dettagliato",
  "tooltip.icons.download": "Scaricare",
  "tooltip.icons.edit": "Modifica",
  "tooltip.icons.help_and_support": "Aiuto/Supporto",
  "tooltip.icons.move": "Spostare",
  "tooltip.icons.qr_code": "Scansiona codice QR",
  "tooltip.icons.search_filter": "Filtro di ricerca",
  "tooltip.icons.search_instructions": "Aiuto per la ricerca",
  "tooltip.icons.view_raw": "Vista grezza",
  "tooltip.icons.view_rendered": "Vista renderizzata",
  "tooltip.open": "Aperto",
  "upload.dropzone.add_files": "Aggiungi file",
  "upload.dropzone.add_files_more": "Aggiungi altri file",
  "upload.dropzone.default_hint": "Trascina e rilascia il file o caricalo",
  "upload.dropzone.dict_cancel_upload": "Annullamento del caricamento",
  "upload.dropzone.dict_fallback_message": "Il vostro browser non supporta il caricamento di file tramite drag & drop",
  "upload.dropzone.dict_fallback_text": "Utilizzate il modulo per caricare i vostri file",
  "upload.dropzone.dict_file_too_big": "Il file è troppo grande. La dimensione massima del file è di {'{'}{'{'}maxFilesize{'}'}{'}'} MB",
  "upload.dropzone.dict_invalid_file_type": "Un file di questo tipo non può essere caricato",
  "upload.dropzone.dict_max_files_exceeded": "Non è possibile caricare altri file",
  "upload.dropzone.dict_remove_file": "Rimuovere il file",
  "upload.dropzone.dict_response_error": "Il server ha rifiutato la richiesta con lo stato {'{'}{'{'}statusCode{'}'}{'}'}.",
  "upload.dropzone.dict_upload_canceled": "Il caricamento è stato annullato",
  "upload.dropzone.files_count_added": "1 file aggiunto | {n} file aggiunti",
  "upload.dropzone.files_count_unsupported": "{n} non supportato",
  "upload.error.axios.ERR_CANCELED": "Il caricamento è stato interrotto",
  "upload.folders": "Cartella | Cartelle",
  "upload.hints.drop_here_to_upload_to": "Rilasciare i file per caricarli:",
  "upload.items": "File | File",
  "upload.no-permissions": "Non hai i permessi per caricare i file.",
  "upload.no_items": "Nessun caricamento",
  "upload.status.added": "Aggiunto",
  "upload.status.canceled": "Cancellato",
  "upload.status.completed": "Completato",
  "upload.status.error": "Fallito",
  "upload.status.processing": "Elaborazione",
  "upload.status.warning": "Avvertenze",
  "upload.uploaded_folders": "{folderName} caricato. | {folderName} {n} di {total} caricato.",
  "upload.uploaded_items": "1 elementi verrà caricato. | Verranno caricati {n} di {total} elementi.",
  "upload.uploaded_items_with_folders": "1 elemento è stato caricato. | {n} di {total} elementi ({numItems} {items}, {numFolders} {folders}) verranno caricati.",
  "upload.uploading_folders": "{folderName} in caricamento. | {folderName} {uploadingCount} di {n} in caricamento.",
  "upload.uploading_items": "1 elementi verrà caricato. | Verranno caricati {n} di {total} elementi.",
  "upload.uploading_items_with_folders": "1 elemento verrà caricato. | {n} di {total} elementi ({numItems} {items}, {numFolders} {folders}) verranno caricati.",
  "upload_qr_code.duration.10_minutes": "10 minuti",
  "upload_qr_code.duration.1_day": "1 giorno",
  "upload_qr_code.duration.1_hour": "1 ora",
  "upload_qr_code.duration.30_minutes": "30 minuti",
  "upload_qr_code.duration.5_minutes": "5 minuti",
  "upload_qr_code.duration.custom": "Personalizzato",
  "upload_qr_code.title": "Scansiona per caricare in {location}",
  "upload_qr_code.valid_for": "Valido per",
  "watches.notifications": "Notifica",
  "watches.stop.disable.text": "Vuoi disattivare le notifiche per {location}?\nIn questo modo non riceverai più email quando verranno aggiunti nuovi documenti.",
  "watches.stop.disable.title": "Disattivare la notifica?",
  "watches.stop.disabled.text": "Le notifiche per {location} sono state disattivate.",
  "watches.stop.disabled.title": "Notifica disattivata",
  "watches.toast.error.error_on_remove_watch": "Errore durante la rimozione dell'osservazione",
  "watches.toast.error.error_on_start_watch": "Errore nell'avvio dell'osservazione",
  "watches.tooltip": "Notifica di nuovi documenti in questa cartella"
}
